import { render, staticRenderFns } from "./breed-table-component.vue?vue&type=template&id=e4628646&scoped=true&lang=pug"
import script from "./breed-table-component.js?vue&type=script&lang=js&external"
export * from "./breed-table-component.js?vue&type=script&lang=js&external"
import style0 from "./breed-table-component.vue?vue&type=style&index=0&id=e4628646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4628646",
  null
  
)

export default component.exports